import { render } from "./PageFooter.vue?vue&type=template&id=487dc808&scoped=true"
import script from "./PageFooter.vue?vue&type=script&lang=js"
export * from "./PageFooter.vue?vue&type=script&lang=js"

import "./PageFooter.vue?vue&type=style&index=0&id=487dc808&scoped=true&lang=css"
/* custom blocks */
import block0 from "@/content/footer.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fmatthias%2Fbusiness%2Fadvanced_quantum%2Fsite%2Ffrontend%2Faq-site%2Fsrc%2Fcomponents%2FPageFooter.vue&lang=json5&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-487dc808"]])

export default __exports__